import { Outlet, useLocation } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { InstallPrompt } from '@/components/profile/InstallPrompt';
import { LevelChangeToast } from '@/components/alianca/LevelChangeToast';
import { ReferralClaimer } from '@/components/referral/ReferralClaimer';
import { UpdateAppBannerHost } from '@/components/app/UpdateAppGate';

export function AppLayout() {
  // Sem TopBar — operador pediu remover o cabeçalho inteiro pra dar mais espaço
  // vertical pro conteúdo (CLAUDE.md ref Screenshot 2026-04-27 155922).
  // Padding-top respeita a safe-area do iOS (notch).
  //
  // InstallPrompt mora aqui (não só em Profile) porque o user pode passar a
  // sessão inteira sem visitar /profile, e Chrome só dispara `beforeinstallprompt`
  // depois do user-engagement heuristic — o componente precisa estar montado
  // pra capturar o evento quando dispara.
  //
  // Routes "imersivas" (cinematic full-bleed) escondem a BottomNav. No
  // redesign atual, só `/charging/*` é imersiva (Em recarga = ousada).
  const location = useLocation();
  // `/charging/*` (recarga) e a tela de cronômetro do aspirador são imersivas.
  const isImmersive =
    location.pathname.startsWith('/charging/') ||
    location.pathname.startsWith('/amenities/sessions/');
  // Rotas no-scroll (viewport fixa): um card inline no topo do main
  // (InstallPrompt) empurra o frame pra fora da tela. Na Home o banner
  // continua existindo — a rota renderiza a própria instância DENTRO do
  // frame (flex item que comprime a lista de estações). Imersivas idem
  // (ActiveCharge/VacuumActive são h-100dvh full-bleed).
  const hideInstallBanner =
    isImmersive ||
    location.pathname === '/' ||
    location.pathname === '/wallet/recharge' ||
    location.pathname === '/alianca' ||
    // Perfil virou viewport fixo (design "Bow Perfil e Indique"): renderiza a
    // própria instância do InstallPrompt DENTRO do frame, como a Home.
    location.pathname === '/profile' ||
    location.pathname.startsWith('/configure/') ||
    location.pathname.startsWith('/receipt/') ||
    location.pathname.startsWith('/amenities/');
  return (
    <div className="flex min-h-screen flex-col bg-bow-cream">
      <main
        className={`flex-1 ${isImmersive ? '' : 'px-4 pb-24'}`}
        style={
          isImmersive
            ? undefined
            : { paddingTop: 'max(1rem, env(safe-area-inset-top))' }
        }
      >
        <InstallPrompt hidden={hideInstallBanner} />
        <LevelChangeToast />
        {/* Aplica o código de indicação pendente (landing /convite ou campo do
            cadastro) assim que há sessão com perfil completo — um só lugar
            cobre email/Google/Apple. */}
        <ReferralClaimer />
        <Outlet />
      </main>
      {/* Faixa "saiu versão nova". Flutuante (fixed acima da BottomNav), não
          inline: um card no fluxo do <main> quebraria as rotas de viewport
          fixa. Por isso ela usa `isImmersive` e não o `hideInstallBanner` —
          só sai de cena nas telas cinematográficas (recarga/aspirador). */}
      <UpdateAppBannerHost hidden={isImmersive} />
      {!isImmersive && <BottomNav />}
    </div>
  );
}
